<ng-container *ngIf="flexFormControlError && flexFormControlError.touched && flexFormControlError.invalid">
    {{ errorMessage }}
</ng-container>
